import {container} from "tsyringe";
import {EntityManager} from "../persistence/entity.manager";
import {Entity} from "../domain/entities/entity";
import {IssueType} from "../domain/entities/issue-type.entity";

/**
 * The issue types the frontend has loaded, read synchronously from the EntityManager cache (the
 * types are preloaded after login). Types created in the browser and not saved yet are left out, so
 * an unsaved child from the type dialog is never offered for an issue.
 */
export function loadedIssueTypes(): IssueType[] {
    return container.resolve(EntityManager).findAllByEntityType<IssueType>(IssueType as unknown as typeof Entity)
        .filter(type => !isUnsavedType(type));
}

/** Whether a type exists only in the browser so far (created in the type dialog, not saved yet). */
export function isUnsavedType(type: IssueType): boolean {
    return container.resolve(EntityManager).isNew(type.uid);
}
